<template>
  <div class="fs12" style="bottom:13px;" @click="$emit('next')">
    <img
      v-if="+type === 1"
      class="next-page"
      width="14"
      src="https://static.wkanx.com/w002/M00/05/E7/CgIXGF6YA8iAVMC-AAABhXcQkF4837.png"
    />
    <img
      v-else
      class="next-page"
      width="14"
      src="https://static.wkanx.com/w002/M00/05/E7/CgIXgV6YDbmAUuoAAAABdaYOpHM001.png"
    />
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    type: { type: [Number, String], default: 2 },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.next-page {
  animation: bounce-down 3s ease-in-out infinite;
}
@keyframes bounce-down {
  25% {
    transform: translateY(3px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
